import React from "react";
import { Link } from "react-router-dom";
import { homePageV2MList } from "../content/homePageV2Content";

export function MListSectionV2() {
  const { bannerImage, categories } = homePageV2MList;

  return (
    <>
      <section className="mh2v2-mlist-hero">
        <img src={bannerImage} alt="M List resources banner" />
        <div className="mh2v2-mlist-hero__badge">M LIST</div>
      </section>

      <section className="mh2v2-mlist mh2v2-section-cream">
        <div className="mh2v2-container">
          <h3 className="mh2v2-section-title mh2v2-section-title--center">THE M LIST</h3>
          <p className="mh2v2-copy mh2v2-copy--center">
            Browse through our list of local resources that have been vetted and vouched for by
            The Mamahood, wearing the M List seal.
          </p>
          <div className="mh2v2-center-actions">
            <Link to="/twentytwentysix/mlist" className="mh2v2-pill mh2v2-pill--gold">
              Browse the M List →
            </Link>
            <Link to="/twentytwentysix/mlist" className="mh2v2-pill mh2v2-pill--gold">
              Join the M List →
            </Link>
          </div>

          <h4 className="mh2v2-section-title mh2v2-section-title--center">CATEGORIES:</h4>

          <div className="mh2v2-category-grid">
            {/* TODO: M List categories API */}
            {categories.map((category) => (
              <article className="mh2v2-category-card" key={category.title}>
                <img src={category.image} alt={category.title} />
                <div className="mh2v2-category-card__overlay">
                  <h5>{category.title}</h5>
                  <Link to={category.to} className="mh2v2-inline-btn">
                    More Info →
                  </Link>
                </div>
                <div className="mh2v2-category-links">
                  {category.ctas.map((cta) => (
                    <Link to={category.to} className="mh2v2-category-link" key={cta}>
                      {cta} →
                    </Link>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default MListSectionV2;
